import {
  React,
  useRef,
  memo,
  Radio,
  useState,
  Box,
  Select,
  DatePicker,
  DatePanel,
  FormControlLabel,
  FormControl,
  toast,
  Button,
  Dialog,
  useCallback,
  Switch,
  RadioGroup,
} from "../../../Libraries/Post/EditPost/Child/EditSidebarContent/index";

const options = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

const EditSidebarContent = (props) => {
  const [layoutsidebardata, setlayoutsidebardata] = useState({
    opendialog: false,
    rowindex: undefined,
    isSidebarScuduled: false,
    isStatus: false,
    opendialogforadd: false,
    opendialogforedit: false,
    selectedOption: [],
    selectedDate: [],
    values: [],
    eselectedDate: undefined,
    eselectedOption: undefined,
    estatusbar: undefined,
    estatus: undefined,
    eradiobuttonvalue: undefined,
  });

  // //this state will open the dialog
  // const [opendialog, setopendialog] = useState(false);

  // //this state will store the index of row which is clicked for editing
  // const [rowindex, setrowindex] = useState();

  // //this state checks weather sidebar is scuduled while adding sidebar
  // const [isSidebarScuduled, setisSidebarScuduled] = useState(false);

  // //this state checks weather sidebar status is true or false
  // const [isStatus, setisStatus] = useState(false);

  // //these two states will handle the dialog body switching
  // const [opendialogforadd, setopendialogforadd] = useState(false);
  // const [opendialogforedit, setopendialogforedit] = useState(false);

  // //this state will store the selected days when sidebar is scuduled
  // const [selectedOption, setSelectedOption] = useState([]);

  // //this state will store the selected date when sidebar is scuduled in date
  // const [selectedDate, setselectedDate] = useState([]);

  // const [values, setValues] = useState([]);

  //this title ref will store the input value of side title while adding
  const title = useRef();
  //this description ref will store the input value of side description while adding
  const desc = useRef();

  //these states are used while editing of sidebar
  // const [eselectedDate, seteselectedDate] = useState();
  // const [eselectedOption, seteselectedOption] = useState([]);
  // const [estatusbar, setestatusbar] = useState();
  // const [estatus, setestatus] = useState();
  // const [eradiobuttonvalue, seteradiobuttonvalue] = useState();
  const etitle = useRef();
  const edesc = useRef();

  //this function will change the value of radion buttons while adding
  const handleChangeRadioButtons = (event) => {
    // props.setradiobuttonvalue(event.target.value);
    // setValues([]);
    // setSelectedOption([]);
    // setselectedDate([])

    props.handleChangeRadioButtonvalue(event.target.value);
    setlayoutsidebardata({
      ...layoutsidebardata,
      values: [],
      selectedOption: [],
      selectedDate: [],
    });
  };

  const handleChangeRadioButtonsedit = (event) => {
    // seteradiobuttonvalue(event.target.value);
    // seteselectedOption([]);
    // setValues([])
    // seteselectedDate([])

    setlayoutsidebardata({
      ...layoutsidebardata,
      values: [],
      eselectedOption: [],
      eselectedDate: [],
      eradiobuttonvalue: event.target.value,
    });
  };

  //this function will handle the add dialog
  const opendialogforaddingrow = () => {
    // setopendialog(true);
    // setopendialogforadd(true);
    // setopendialogforedit(false);

    setlayoutsidebardata({
      ...layoutsidebardata,
      opendialog: true,
      opendialogforadd: true,
      opendialogforedit: false,
    });
  };

  const handlesetSelectedOption = (e) => {
    setlayoutsidebardata({
      ...layoutsidebardata,
      selectedOption: e,
    });
  };
  const handleChangeeselectedOption = (e) => {
    setlayoutsidebardata({
      ...layoutsidebardata,
      eselectedOption: e,
    });
  };

  //this function will handle the edit dialog
  const opendialogforeditrow = (index) => {
    const editData = props.rowsData.filter((item, i) => i === index && item);
    if (editData.length === 1) {
      var match =
        editData[0].days !== "N/A" ? editData[0]?.days.split(",") : [];
      const result = match.map((value) => ({ label: value, value }));
      setlayoutsidebardata({
        ...layoutsidebardata,
        eselectedOption: result,
        estatusbar: editData[0].is_scheduled,
        estatus: editData[0].txt_status,
        eradiobuttonvalue: editData[0].date_wise_or_day_wise,
        values:
          editData[0].date_wise_or_day_wise === "Date wise"
            ? editData[0].date_wise_scheduled_date.split(",")
            : [],
        eselectedDate:
          editData[0].date_wise_or_day_wise === "Date wise"
            ? editData[0].date_wise_scheduled_date
            : [],
        rowindex: index,
        opendialog: true,
        opendialogforedit: true,
        opendialogforadd: false,
      });

      // seteselectedOption(result);
      // setestatusbar(editData[0].is_scheduled);
      // setestatus(editData[0].txt_status);
      // seteradiobuttonvalue(editData[0].date_wise_or_day_wise);
      // if (editData[0].date_wise_or_day_wise === "Date wise") {
      //   setValues(editData[0].date_wise_scheduled_date.split(","));
      // } else {
      //   setValues([])
      // }
      // setrowindex(index);
      // setopendialog(true);
      // setopendialogforedit(true);
      // setopendialogforadd(false);
    } else {
      toast.error("Something went wrong");
    }
  };

  //this function will change the value of sidebar scudluding switch while adding
  const handleChange = (event) => {
    // setisSidebarScuduled(event.target.checked);
    // props.setradiobuttonvalue('')
    // setSelectedOption([])
    // setValues([])

    props.handleChangeRadioButtonvalue("");
    setlayoutsidebardata({
      ...layoutsidebardata,
      isSidebarScuduled: event.target.checked,
      selectedOption: [],
      values: [],
    });
  };

  //this function will change the value of sidebar status while adding
  const handleChangeStatus = (event) => {
    // setisStatus(event.target.checked);
    setlayoutsidebardata({
      ...layoutsidebardata,
      isStatus: event.target.checked,
    });
  };

  //this function will change the value of sidebar scudlued while editing
  const handleChangescuduledswitch = (event) => {
    // setestatusbar(event.target.checked);
    // seteradiobuttonvalue('')
    // seteselectedOption([]);
    // setValues([]);
    // setselectedDate([]);

    setlayoutsidebardata({
      ...layoutsidebardata,
      values: [],
      eselectedOption: [],
      selectedDate: [],
      eradiobuttonvalue: "",
      estatusbar: event.target.checked,
    });
  };

  //this function will change the value of sidebar status while editing
  const handleChangeestatus = (event) => {
    // setestatus(event.target.checked);
    setlayoutsidebardata({
      ...layoutsidebardata,
      estatus: event.target.checked,
    });
  };

  //this function will change the value of sidebar status while adding
  const handleChangeDate = (v) => {
    // setValues(v);
    // setselectedDate(datesx.toString());
    const datesx = v.map((date) => date.format());
    setlayoutsidebardata({
      ...layoutsidebardata,
      values: v,
      selectedDate: datesx.toString(),
    });
  };

  //this function will change the value of sidebar status while editing
  const handleChangeDatee = (v) => {
    // setValues(v);
    // seteselectedDate(datesx.toString());
    const datesx = v.map((date) => date.format());
    setlayoutsidebardata({
      ...layoutsidebardata,
      values: v,
      eselectedDate: datesx.toString(),
    });
  };
  //add
  const addTableRows = () => {
    if (
      title.current.value === undefined ||
      title.current.value === "undefined" ||
      title.current.value === null ||
      title.current.value === "null" ||
      title.current.value === ""
    ) {
      toast.error("Please add the sidebar title");
    } else if (
      desc.current.value === undefined ||
      desc.current.value === "undefined" ||
      desc.current.value === null ||
      desc.current.value === "null" ||
      desc.current.value === ""
    ) {
      toast.error("Please add the sidebar description");
    } else if (
      layoutsidebardata.isSidebarScuduled &&
      props.data.radiobuttonvalue === "Day wise" &&
      layoutsidebardata.selectedOption.length === 0
    ) {
      toast.error("Please select the days");
    } else if (
      layoutsidebardata.isSidebarScuduled &&
      props.data.radiobuttonvalue === "Date wise" &&
      layoutsidebardata.selectedDate.length === 0
    ) {
      toast.error("Please select the date");
    } else if (
      layoutsidebardata.isSidebarScuduled &&
      props.data.radiobuttonvalue === ""
    ) {
      toast.error("Please choose the date/days");
    } else {
      const formatedscudlueddays = String(
        layoutsidebardata.selectedOption?.map((day) => day.value)
      );
      const rowsInput = {
        txt_sidebar_title: title.current.value,
        txt_sidebar_description: desc.current.value,
        txt_status: layoutsidebardata.isStatus,
        is_scheduled: layoutsidebardata.isSidebarScuduled,
        days:
          layoutsidebardata.isSidebarScuduled === true &&
          props.data.radiobuttonvalue === "Day wise"
            ? formatedscudlueddays
            : "N/A",
        date_wise_or_day_wise:
          layoutsidebardata.isSidebarScuduled === true
            ? props.data.radiobuttonvalue
            : "N/A",
        date_wise_scheduled_date:
          layoutsidebardata.isSidebarScuduled === true &&
          props.data.radiobuttonvalue === "Date wise"
            ? layoutsidebardata.selectedDate
            : "N/A",
      };
      props.setRowsData([...props.rowsData, rowsInput]);
      title.current.value = "";
      desc.current.value = "";
      setlayoutsidebardata({
        ...layoutsidebardata,
        isSidebarScuduled: false,
        selectedOption: [],
        selectedDate: [],
        values: [],
        isStatus: false,
      });
      // setisSidebarScuduled(false);
      // setSelectedOption([]);
      // setselectedDate([]);
      // setValues([]);
      // setisStatus(false);
    }
  };

  //delete
  const deleteTableRows = (index) => {
    const rows = [...props.rowsData];
    rows.splice(index, 1);
    props.setRowsData(rows);
  };

  //onDialoghide
  const hideDialog = useCallback(() => {
    // setopendialog(false);
    // props.setradiobuttonvalue('');
    // setValues([])
    // setisSidebarScuduled(false);
    // setisStatus(false)

    props.handleChangeRadioButtonvalue("");
    setlayoutsidebardata({
      ...layoutsidebardata,
      opendialog: false,
      values: [],
      isSidebarScuduled: false,
      isStatus: false,
    });
  }, [props, layoutsidebardata]);

  //this function will be called when user edit sidebar data
  const EditRowData = useCallback(() => {
    if (
      etitle.current.value === undefined ||
      etitle.current.value === "undefined" ||
      etitle.current.value === null ||
      etitle.current.value === "null" ||
      etitle.current.value === ""
    ) {
      toast.error("Sidebar title not to be empty");
    } else if (
      edesc.current.value === undefined ||
      edesc.current.value === "undefined" ||
      edesc.current.value === null ||
      edesc.current.value === "null" ||
      edesc.current.value === ""
    ) {
      toast.error("Sidebar description not to be empty");
    } else if (
      layoutsidebardata.estatusbar &&
      layoutsidebardata.eradiobuttonvalue === ""
    ) {
      toast.error("Please choose the date/days");
    } else if (
      layoutsidebardata.estatusbar &&
      layoutsidebardata.eradiobuttonvalue === "Day wise" &&
      layoutsidebardata.eselectedOption.length === 0
    ) {
      toast.error("Please select the Days");
    } else if (
      layoutsidebardata.estatusbar &&
      layoutsidebardata.eradiobuttonvalue === "Date wise" &&
      layoutsidebardata.eselectedDate.length === 0
    ) {
      toast.error("Please select the Dates");
    } else {
      const formatedscudlueddays = String(
        layoutsidebardata.eselectedOption?.map((day) => day.value)
      );
      const editData = props?.rowsData.map((item, index) =>
        index === layoutsidebardata.rowindex
          ? {
              ...item,
              txt_sidebar_title: etitle.current.value,
              txt_sidebar_description: edesc.current.value,
              txt_status: layoutsidebardata.estatus,
              is_scheduled: layoutsidebardata.estatusbar,
              days:
                layoutsidebardata.estatusbar === true &&
                layoutsidebardata.eradiobuttonvalue === "Day wise"
                  ? formatedscudlueddays
                  : "N/A",
              date_wise_or_day_wise:
                layoutsidebardata.estatusbar === true
                  ? layoutsidebardata.eradiobuttonvalue
                  : "N/A",
              date_wise_scheduled_date:
                layoutsidebardata.estatusbar === true &&
                layoutsidebardata.eradiobuttonvalue === "Date wise"
                  ? layoutsidebardata.eselectedDate
                  : "N/A",
            }
          : item
      );
      props.setRowsData(editData);
      hideDialog();
    }
  }, [layoutsidebardata, props, hideDialog]);

  const addsidebarfooter = (
    <React.Fragment>
      <Button variant="contained" onClick={addTableRows} className="capitalized fs-14 fw-bold">
        Add
      </Button>
    </React.Fragment>
  );

  const savesidebarfooter = (
    <React.Fragment>
      <Button variant="contained" onClick={EditRowData} className="capitalized fs-14 fw-bold">
        save
      </Button>
    </React.Fragment>
  );

  //SSBR Use this
  const safeSidebarRow =
  Array.isArray(props.rowsData) &&
  Number.isInteger(layoutsidebardata.rowindex) &&
  layoutsidebardata.rowindex >= 0 &&
  layoutsidebardata.rowindex < props.rowsData.length
    ? props.rowsData[layoutsidebardata.rowindex]
    : null;


  return (
    <>
      <Box sx={{ flexGrow: 1, mb: 2, ml: 2, mr: 1 }}>
        <div className="sideBarDiv">
          <div id="labelDiv">
            <label id="sideHeadLabel">Sidebar post</label>
          </div>
          <div id="addBtnDiv">
            <div id="blueBtnSubDiv">
              <Button
                variant="primary"
                id="blueAddBtn"
                onClick={opendialogforaddingrow}
                className="capitalized fs-14 fw-bold"
              >
                Add
              </Button>
            </div>
          </div>
        </div>
        <div>
          <div className="shadow-4 rounded-1 overflow-hidden">
            <table className="table align-middle mb-0 bg-white">
              <thead className="bg-light">
                <tr>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Title
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Description
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Schedule Status
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      width: "20%",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.rowsData &&
                  props.rowsData.map((row, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          width: "20%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.txt_sidebar_title}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {row.txt_sidebar_description}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Switch
                          checked={row.is_scheduled}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </td>

                      <td
                        style={{
                          width: "20%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Switch
                          checked={row.txt_status}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </td>

                      <td
                        style={{
                          width: "25%",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <div>
                          <Button onClick={() => deleteTableRows(index)} className="capitalized fs-14 fw-bold">
                            Delete
                          </Button>
                        </div>
                        <div>
                          <Button onClick={() => opendialogforeditrow(index)} className="capitalized fs-14 fw-bold">
                            Edit
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <Dialog
          visible={layoutsidebardata.opendialog}
          style={{ width: "500px" }}
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          header={
            layoutsidebardata.opendialogforadd ? "Add Sidebar" : "Edit Sidebar"
          }
          modal
          footer={
            layoutsidebardata.opendialogforadd
              ? addsidebarfooter
              : savesidebarfooter
          }
          onHide={hideDialog}
        >
          {layoutsidebardata.opendialogforadd &&
          !layoutsidebardata.opendialogforedit ? (
            <>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Sidebar Title</label>
                    <input
                      type="text"
                      ref={title}
                      className="form-control"
                      id="formControlRange"
                      placeholder="Title"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="exampleFormControlTextarea1">
                    Description
                  </label>
                  <textarea
                    ref={desc}
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Sidebar Schedule</label>
                    <Switch
                      checked={layoutsidebardata.isSidebarScuduled}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
              {layoutsidebardata.isSidebarScuduled && (
                <>
                  <div className="row">
                    <div className="col">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group"
                          name="demo-row-radio-buttons-group"
                          value={props.data.radiobuttonvalue}
                          onChange={handleChangeRadioButtons}
                        >
                          <FormControlLabel
                            value="Day wise"
                            control={<Radio />}
                            label="Day wise"
                          />
                          <FormControlLabel
                            value="Date wise"
                            control={<Radio />}
                            label="Date wise"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  {props.data.radiobuttonvalue === "Day wise" ? (
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="formControlRange">
                            Schedule Days
                          </label>
                          <Select
                            options={options}
                            onChange={handlesetSelectedOption}
                            isMulti="true"
                            isClearable={true}
                            name="scudleddays"
                            placeholder="Select Days"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : props.data.radiobuttonvalue === "Date wise" ? (
                    <div className="row">
                      <div className="col">
                        <DatePicker
                          multiple
                          sort
                          calendarPosition="bottom-center"
                          value={layoutsidebardata.values}
                          onChange={handleChangeDate}
                          plugins={[
                            <DatePanel key={layoutsidebardata.values} />,
                          ]}
                        />
                      </div>
                    </div>
                  ) : null}
                </>
              )}
              <div className="row">
                <div className="col ">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Status</label>
                    <Switch
                      checked={layoutsidebardata.isStatus}
                      onChange={handleChangeStatus}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : !layoutsidebardata.opendialogforadd &&
            layoutsidebardata.opendialogforedit ? (
            <>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Edit Sidebar Title</label>
                    <input
                      type="text"
                      name="title"
                      ref={etitle}
                    //SSBR use this
                    defaultValue={safeSidebarRow?.txt_sidebar_title || ""}
                      // defaultValue={
                      //   props.rowsData[layoutsidebardata.rowindex]// Issue reported
                      //     ?.txt_sidebar_title
                      // }
                      className="form-control"
                      id="formControlRange"
                      placeholder="Title"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="exampleFormControlTextarea1">
                    Edit Description
                  </label>
                  <textarea
                    className="form-control"
                    name="description"
                    ref={edesc}
                    //SSBR use this
                    defaultValue={safeSidebarRow?.txt_sidebar_description || ""}
                    // defaultValue={
                    //   props.rowsData[layoutsidebardata.rowindex]// ISsue reported
                    //     ?.txt_sidebar_description
                    // }
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="formControlRange">
                      Edit Sidebar Schedule
                    </label>
                    <Switch
                      checked={layoutsidebardata.estatusbar}
                      onChange={handleChangescuduledswitch}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
              {layoutsidebardata.estatusbar && (
                <>
                  <div className="row">
                    <div className="col">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group"
                          name="demo-row-radio-buttons-group"
                          value={layoutsidebardata.eradiobuttonvalue}
                          onChange={handleChangeRadioButtonsedit}
                        >
                          <FormControlLabel
                            value="Day wise"
                            control={<Radio />}
                            label="Day wise"
                          />
                          <FormControlLabel
                            value="Date wise"
                            control={<Radio />}
                            label="Date wise"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  {layoutsidebardata.eradiobuttonvalue === "Day wise" ? (
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="formControlRange">
                            Edit Schedule Days
                          </label>
                          <Select
                            options={options}
                            name="scudlueddays"
                            defaultValue={layoutsidebardata.eselectedOption}
                            onChange={handleChangeeselectedOption}
                            isMulti="true"
                            isClearable={true}
                            placeholder="Select Days"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : layoutsidebardata.eradiobuttonvalue === "Date wise" ? (
                    <div className="row">
                      <div className="col">
                        <DatePicker
                          multiple
                          sort
                          calendarPosition="bottom-center"
                          value={layoutsidebardata.values}
                          onChange={handleChangeDatee}
                          plugins={[
                            <DatePanel key={layoutsidebardata.values} />,
                          ]}
                        />
                      </div>
                    </div>
                  ) : null}
                </>
              )}
              <div className="row">
                <div className="col ">
                  <div className="form-group">
                    <label htmlFor="formControlRange">Edit Status</label>
                    <Switch
                      checked={layoutsidebardata.estatus}
                      onChange={handleChangeestatus}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </Dialog>
      </Box>
    </>
  );
};

export default memo(EditSidebarContent);
